import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {IconCode} from '../../enums/icon-code.enum';
import {PermissionArea} from '../../enums/permission-area.enum';

@Injectable()
export class NavMigratedPoliciesFactory extends NavFactory {
    protected static basePath = '/migrated-policies';
    protected static items = [
        {
            code: NavItemCodes.MIGRATED_POLICIES,
            icon: IconCode.MIGRATED_POLICIES,
            label: 'NAV.MIGRATED_POLICIES.LABEL',
            description: 'NAV.MIGRATED_POLICIES.DESC',
            path: NavMigratedPoliciesFactory.basePath,
            permissionArea: PermissionArea.MIGRATED_POLICY_REGISTRY,
            cy: 'migrated-policies'
        },
        {
            code: NavItemCodes.MIGRATED_POLICIES_LABEL_SHORT,
            icon: IconCode.MIGRATED_POLICIES,
            label: 'NAV.MIGRATED_POLICIES.LABEL_SHORT',
            path: NavMigratedPoliciesFactory.basePath,
            permissionArea: PermissionArea.MIGRATED_POLICY_REGISTRY,
        },
        {
            code: NavItemCodes.MIGRATED_POLICIES_VIEW,
            icon: IconCode.PREVIEW,
            label: 'MIGRATED_POLICIES.MIGRATED_POLICY',
            path: ({policyId}) => [NavMigratedPoliciesFactory.basePath, policyId],
        },
    ];
}
